<div class="layout-col full gap-xl">
  <mat-toolbar elderTheme>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>

    <span class="flex"></span>

    <button mat-flat-button [disabled]="!selectedNode" (click)="close(selectedNode)">
      {{ 'actions.select' | translate }}
    </button>
  </mat-toolbar>

  <app-storage-node-table
    class="flex"
    [storageNodeIds]="storageNodesIds"
    (selectionSingleChange)="selectedNode = $event"
  >
  </app-storage-node-table>
</div>
